<template>
  <view-wrapper
    :show-back-button="true"
    name="QualityAssurance - Preview"
    :path="'qa/labels/' + this.$route.params.labelId + '/details'"
    back-text="Back to details"
    :loading="loading"
    loading-text="Loading QualityAssuranceLabelPreview">
    <div class="float-right font-semibold">
      <span v-if="!!message">
        {{message}}
      </span>
    </div>

    <wrapper class="mb-3 p-5" >
      <label-comparisons
        :data="versions"
        :printers="printers"
      />
    </wrapper>

    <wrapper class="mb-3 p-5" >
      <label-variables-delta
        :data="versions"
      />
    </wrapper>

    <grafokett-button class="big ml-2 bg-primary text-textcolor" @click="modalApprove = !modalApprove">Send for approval</grafokett-button>
    <grafokett-button class="big ml-2 bg-primary text-textcolor" @click="gotoReplace()">Replace with new file</grafokett-button>
    <grafokett-button class="big ml-2 bg-primary text-textcolor" @click="abandon()">Abandon</grafokett-button>

    <modal
      v-if="modalApprove"
      :type="'success'"
      @close="modalApprove = !modalApprove"
    >
      <template slot="body" >
        <div class="p-2 my-2" >
          <comment-box placeholderText="Describe changes to approve..." v-model="comment" />
        </div>
      </template>
      <template slot="buttons" >
        <div>
          <grafokett-button
            type="primary"
            class="big bg-white border-primary text-primary"
            @click="sendForApproval"
          >Send</grafokett-button>
          <grafokett-button
            class="big ml-2 bg-primary text-textcolor"
            @click="modalApprove = !modalApprove"
          >Cancel</grafokett-button
          >
        </div>
      </template>
    </modal>

    <modal
      v-if="approvalSuccessful"
      :type="'success'"
      :heading="'Label design sent for approval'"
      @close="approvalSuccessful = !approvalSuccessful"
    >
      <template slot="buttons" >
        <div>
          <grafokett-button
            class="big bg-white border-primary text-primary"
            @click="gotoApproval"
          >Go to Approve</grafokett-button
          >
          <grafokett-button
            class="big ml-2 bg-primary text-textcolor"
            @click="goBack"
          >Go back to details</grafokett-button
          >
        </div>
      </template>
    </modal>

    <modal
      v-if="approvalWarning"
      :type="'warning'"
      :heading="'Something went wrong!'"
      @close="approvalWarning = !approvalWarning"
    >
      <template slot="buttons" >
        <div>
          <grafokett-button
            class="big ml-2 bg-primary text-textcolor"
            @click="goBack"
          >Go back to details</grafokett-button
          >
        </div>
      </template>
    </modal>


  </view-wrapper>
</template>

<script>

import GrafokettButton from '../../../components/forms/Button.vue';
import LabelComparisons from "components/LabelComparisons";
import LabelVariablesDelta from "components/LabelVariablesDelta";
import Modal from "components/Modal";
import CommentBox from "components/CommentBox";

export default {
  components: {
    CommentBox,
    GrafokettButton,
    LabelComparisons,
    LabelVariablesDelta,
    Modal
  },
  data: () => ({
    loading: false,
    message: "",
    versions: [],
    modalApprove: false,
    approvalSuccessful: false,
    approvalWarning: false,
    comment: '',
    label: null
  }),
  computed: {
    printers () {
      return this.$store.getters['PRINTERS/INSTALLED_PRINTERS'];
    },
  },
  methods: {
    async getData () {
      try {
        this.loading = true;
        await this.$store.dispatch('QUALITY_ASSURANCE/GET_PREVIEW', this.$route.params);
        this.versions = [this.$store.getters['QUALITY_ASSURANCE/PREVIEW']].map(d => ({
          labelId: this.$route.params.labelId,
          versionId: this.$route.params.versionId,
          quantity: 1,
          name: this.label.name,
          variablesDelta: d.variablesDelta,
          diff: {
            preview: d.design.diffPng == null ?  '' : "data:image/png;base64, " + d.design.diffPng
          },
          left: {
            variables: d.variables.leftVariables,
            preview: "data:image/png;base64, " + d.design.leftPng
          },
          right: {
            variables: d.variables.rightVariables,
            preview: d.design.rightPng == null ?  '' :  "data:image/png;base64, " + d.design.rightPng}
        }));
        this.loading = false;
      } catch(error) {
        this.loading = false
        this.approvalWarning = true
      }
    },
    gotoApproval() {
      this.loading = true;
      this.modalApprove = false;
      this.$router.push(`/qa/labels/${this.$route.params.labelId}/versions/${this.$route.params.versionId}/approve`);
    },
    async sendForApproval() {
      try {
        this.loading = true
        this.modalApprove = false;
        const payload = {
          labelId: parseInt(this.$route.params.labelId),
          labelVersionId: parseInt(this.$route.params.versionId),
          comment: this.comment
        }
        const response = await this.$store.dispatch('QUALITY_ASSURANCE/SET_READY_FOR_APPROVAL', payload)
        if(response.data.success) {
          this.approvalSuccessful = true
          this.loading = false
        } else {
          this.approvalSuccessful = false
          this.approvalWarning = true
          this.loading = false
        }
      } catch(error) {
        this.loading = false
        this.approvalSuccessful = false
        this.approvalWarning = true
        this.modalApprove = false
        throw error
      }
    },
    gotoReplace() {
      this.loading = true;
      this.modalApprove = false;
      this.$router.push(`/qa/labels/${this.$route.params.labelId}/versions/${this.$route.params.versionId}/replace`);
    },
    async abandon() {
      this.loading = true;
      await this.$store.$api.delete(`/api/QualityAssurance/labels/${this.$route.params.labelId}/version/${this.$route.params.versionId}/abandon`);
      this.goBack();
    },
    goBack() {
        this.$router.push(`/qa/labels/${this.$route.params.labelId}/details`)
    }
  },
  async mounted () {
    if (this.printers.length === 0) {
      await this.$store.dispatch('PRINTERS/GET_INSTALLED_PRINTERS');
    }
    if(!this.label) {
      const response = await this.$store.$api.get(`/api/labels/${this.$route.params.labelId}`);
      this.label = { ...response.data.data };
    }
    await this.getData();
  }
}
</script>
